import React, { useEffect, useMemo, useState } from 'react'

import { useSearchParam } from '../../../../hooks'
import { filterNodes } from '../../../../utils/history/filterNodes'
import { traverse } from '../../../../utils/history/traverse'
import { useDeliveryForecastHistory } from '../data/hook'
import { History } from './History'

export const HistoryContainer: React.FC = () => {
  const [searchParam, setSearchParam] = useSearchParam('search')
  const { data } = useDeliveryForecastHistory()
  const [expandedKeys, setExpandedKeys] = useState<Record<string, boolean>>({})

  // Automatisch alle übereinstimmenden Knoten aus-/zuklappen
  useEffect(() => {
    traverse(filteredNodes!, searchParam, setExpandedKeys)
  }, [searchParam])

  // Gefilterte Knoten mit useMemo für Performance optimieren
  const filteredNodes = useMemo(
    () => filterNodes(data!, searchParam),
    [data, searchParam],
  )

  return (
    <History
      data={filteredNodes}
      search={searchParam}
      setSearch={setSearchParam}
      expandedKeys={expandedKeys}
      setExpandedKeys={setExpandedKeys}
    />
  )
}
